var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshot = function SvgScreenshot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "screenshot_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.83 7H24c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4.17L12 5h6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.83 7-1.475 1.35.594.65h.881zm-9.66 0v2h.88l.595-.65zM12 5V3h-.88l-.595.65zm6 0 1.476-1.35L18.88 3H18zm1.83 2v2H24V5h-4.17zM24 7v2h4c0-2.205-1.795-4-4-4zm2 2h-2v12h4V9zm0 12h-2v4c2.205 0 4-1.795 4-4zm-2 2v-2H6v4h18zM6 23v-2H2c0 2.205 1.795 4 4 4zm-2-2h2V9H2v12zM4 9h2V5C3.795 5 2 6.795 2 9zm2-2v2h4.17V5H6zm4.17 0 1.475 1.35 1.83-2L12 5l-1.476-1.35-1.83 2zM12 5v2h6V3h-6zm6 0-1.476 1.35 1.83 2L19.83 7l1.476-1.35-1.83-2z",
    mask: "url(#screenshot_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M15 10.75a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.11 12.055a1.11 1.11 0 1 0 0-2.22 1.11 1.11 0 0 0 0 2.22"
  })));
};
export default SvgScreenshot;